import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Form, Input } from "antd";
import PropTypes from "prop-types";
import { Col } from "antd";
import "antd/dist/antd.min.css";
import "../../../styles/Main.scss";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import { patchRequest } from "../../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
// import TextAreaField from "../../../common/htmlComponents/TextAreaField";

const RequestedStatusDiscard = ({
  handleCancel,
  userId,
  changeCurrentStatus,
  setReload,
  reload,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const { TextArea } = Input;
  const initialState = {
    status: changeCurrentStatus,
    remark: "",
  };
  const [btnLoading, setBtnLoading] = useState(false);
  const [state, setState] = useState(initialState);
  const backToList = () => {
    setState(initialState);
    formRef.current.setFieldsValue(initialState);
    handleCancel();
  };
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleSubmit = async () => {
    if (!state.remark) {
      // Prevent form submission if no document is uploaded
      ErrorNotificationMsg(t("val_remark"));
      return;
    }

    try {
      setBtnLoading(true);
      let response;

      response = await patchRequest(`request-demo-status/${userId}/`, state);

      if (response.data.success) {
        SuccessNotificationMsg(t("status_changed_successfully"));

        setState(initialState);
        formRef.current.setFieldsValue(initialState);

        setBtnLoading(false);
        handleCancel();
        setReload(!reload);
      }
    } catch (error) {
      ErrorNotificationMsg(t("error_in_changing_status"));
      setBtnLoading(false);
    }
  };

  return (
    <>
      <div>
        <Form
          className="ModalForm"
          autoComplete="off"
          onFinish={handleSubmit}
          ref={formRef}
        >
          <Col md={24} className="TextFeild">
            {/* <TextAreaField
              name="remark"
              label={t("label_place_remark")}
              placeholder={t("place_remark")}
              // prefix={<About />}
              autoSize={{ minRows: 5, maxRows: 15 }}
              handleInputChange={handleInputChange}
            /> */}
            <Form.Item name="remark" label={t("label_place_remark")}>
              <TextArea
                name="remark" // Ensure the TextArea has a name attribute
                placeholder={t("place_remark")}
                value={state.remark}
                onChange={handleInputChange}
                autoSize={{ minRows: 5, maxRows: 10 }} // Adjust minRows and maxRows as needed
              />
            </Form.Item>
          </Col>
          <div className="ModalPopupFooter">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("cancel")}
              onClick={backToList}
            />
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="Submit"
              label={t("save")}
              loading={btnLoading}
            />
          </div>
        </Form>
      </div>
    </>
  );
};

RequestedStatusDiscard.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  userId: PropTypes.number,
  changeCurrentStatus: PropTypes.string,
  setReload: PropTypes.func.isRequired,
  reload: PropTypes.bool,
};

export default RequestedStatusDiscard;
